import { useState } from "react";
import {
	User,
	Reservation,
	Service,
	emptyUser,
	emptyReservation,
} from "../types/entities";
import { Dayjs } from "dayjs";

//This custom hook has the information needed of the navigation in the app
export function useMultistep() {
	//The active step where the user is stopped, the home is step -1
	const [activeStep, setActiveStep] = useState(0);

	//It contains the information of the current reservation
	const [reservation, setReservation] = useState<Reservation>(
		emptyReservation(emptyUser)
	);

	const [reservationMade, setReservationMade] = useState(false);

	//Navigation functions
	const onNext = () => {
		setActiveStep(activeStep + 1);
	};

	const onPrev = () => {
		setActiveStep(activeStep - Math.sign(activeStep));
	};

	const onReset = () => {
		setActiveStep(0);
		setReservation(emptyReservation(reservation.customer));
		setReservationMade(false);
	};

	const onChangeStep = (step: number) => {
		setActiveStep(step);
	};

	//Data changing functions
	const onChangeNumberDiners = (numberDiners: number) => {
		setReservation({ ...reservation, numberDiners });
	};

	const onChangeDate = (date: Dayjs) => {
		const [day, month, year] = date.format("DD-MM-YYYY").split("-");
		const time = new Date(Number(year), Number(month) - 1, Number(day));
		if (reservation.schedule) {
			time.setHours(parseInt(reservation.schedule.substring(0, 2)));
			time.setMinutes(parseInt(reservation.schedule.substring(3, 5)));
		} else {
			time.setHours(0);
			time.setMinutes(0);
		}
		setReservation({ ...reservation, time });
	};
	// I add the schedule property because when I tried to set the hour of the reservation, without the
	// date of the reservation, I couldn't do it without setting a date first.
	// When I have the date of the reservation, I set the schedule into the date, if not, I store it in "schedule"
	const onChangeTime = (scheduleTime: string | null) => {
		if (scheduleTime === null) {
			setReservation({ ...reservation, time: null, schedule: "" });
			return;
		}
		if (reservation.time) {
			const time = reservation.time;
			time.setHours(parseInt(scheduleTime.substring(0, 2)));
			time.setMinutes(parseInt(scheduleTime.substring(3, 5)));
			setReservation({ ...reservation, time, schedule: scheduleTime });
		} else {
			setReservation({ ...reservation, schedule: scheduleTime });
		}
	};

	const onChangeService = (service: Service) => {
		setReservation({ ...reservation, service });
	};

	const onChangeLogin = (customer: User) => {
		setReservation({ ...reservation, customer });
	};

	const onChangeBookingFee = (bookingFee: number) => {
		setReservation({ ...reservation, bookingFee });
	};

	const onSubmit = (newReservation?: Reservation, step?: number) => {
		console.log(`Datos de la reserva enviada:`);
		console.log(newReservation);
		setReservationMade(true);
		if (newReservation) setReservation(newReservation);
		if (step) setActiveStep(step);
		//setReservation(emptyReservation(reservation.customer)); // Reset the reservation to empty when the reservation is submitted
	};

	return {
		activeStep,
		reservation,
		setReservation,
		onNext,
		onPrev,
		onReset,
		onChangeStep,
		onChangeNumberDiners,
		onChangeDate,
		onChangeService,
		onChangeTime,
		onChangeLogin,
		onChangeBookingFee,
		onSubmit,
		reservationMade,
		setReservationMade,
	};
}
